import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=37dd9e5e&"
import script from "./Event.ts?vue&type=script&lang=js&"
export * from "./Event.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports